export const FAQStyles = {
  root: {
    minHeight: '111.11vh',
    background: 'linear-gradient(to bottom, rgb(227, 248, 255), rgb(120, 162, 240))',
    padding: 0,
  },
  headerSection: {
    background: '#231f1e',
    color: '#fff',
    padding: { xs: '60px 20px', md: '80px 40px' },
    textAlign: 'center',
  },
  title: {
    fontSize: { xs: '2.5rem', md: '3.5rem' },
    fontWeight: 700,
    color: '#b3c6e7',
    fontFamily: '"Higuen Serif", serif',
    marginBottom: 2,
    letterSpacing: 2,
  },
  subtitle: {
    fontSize: { xs: '1.1rem', md: '1.3rem' },
    color: '#e0d7ce',
    maxWidth: '800px',
    margin: '0 auto',
    lineHeight: 1.6,
  },
  mainContent: {
    padding: { xs: '40px 20px', md: '60px 40px' },
  },
  categorySection: {
    marginBottom: 4,
  },
  categoryTitle: {
    fontSize: '2rem',
    fontWeight: 600,
    color: '#231f1e',
    fontFamily: '"Higuen Serif", serif',
    marginBottom: 2,
    textAlign: 'center',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '60px',
      height: '3px',
      background: 'linear-gradient(90deg, #ffa726, #1976d2)',
      borderRadius: '2px',
    },
  },
  accordionContainer: {
    borderRadius: '16px',
    background: '#fff',
    boxShadow: '0 4px 32px 0 rgba(44, 26, 126, 0.08)',
    border: '2px solid #e3f8ff',
    overflow: 'hidden',
  },
  accordion: {
    '&:not(:last-child)': {
      borderBottom: '1px solid #e3f8ff',
    },
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  accordionSummary: {
    padding: { xs: '16px 20px', md: '20px 24px' },
    backgroundColor: '#f7f9fb',
    '&:hover': {
      backgroundColor: '#e3f8ff',
    },
    '&.Mui-expanded': {
      backgroundColor: '#e3f8ff',
      minHeight: 'auto',
    },
    '& .MuiAccordionSummary-content': {
      margin: '12px 0',
      '&.Mui-expanded': {
        margin: '12px 0',
      },
    },
  },
  accordionDetails: {
    padding: { xs: '16px 20px', md: '20px 24px' },
    backgroundColor: '#fff',
  },
  question: {
    fontSize: { xs: '1rem', md: '1.1rem' },
    fontWeight: 600,
    color: '#231f1e',
    lineHeight: 1.4,
  },
  answer: {
    fontSize: { xs: '0.95rem', md: '1rem' },
    color: '#231f1e',
    opacity: 0.8,
    lineHeight: 1.6,
  },
  contactCTA: {
    marginTop: 4,
    padding: { xs: '30px 20px', md: '40px' },
    background: '#fff',
    borderRadius: '20px',
    boxShadow: '0 4px 32px 0 rgba(44, 26, 126, 0.08)',
    border: '2px solid #e3f8ff',
    textAlign: 'center',
  },
  contactTitle: {
    fontSize: '2rem',
    fontWeight: 600,
    color: '#231f1e',
    fontFamily: '"Higuen Serif", serif',
    marginBottom: 1,
  },
  contactSubtitle: {
    fontSize: '1.1rem',
    color: '#231f1e',
    opacity: 0.8,
    marginBottom: 2,
    lineHeight: 1.6,
  },
  contactButtons: {
    display: 'flex',
    justifyContent: 'center',
    gap: 2,
  },
  contactText: {
    fontSize: '1rem',
    color: '#231f1e',
    opacity: 0.8,
    '& a': {
      fontWeight: 600,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
};
